import { Component } from '@angular/core'
import { AgRendererComponent } from 'ag-grid-angular'
import { Option } from 'common-components'

@Component({
  selector: 'app-episode-type-renderer',
  template: ` <span title="{{ episodeTypeName }}">{{ episodeTypeName }}</span> `,
  standalone: false
})
export class EpisodeTypeRendererComponent implements AgRendererComponent {
  private params: any
  private episodeTypesList: Option[]
  public episodeTypeName: string

  agInit(params: any): void {
    this.params = params
    this.episodeTypesList = params.context.episodeTypesList

    if (params.data['EpisodeTypeIds']) {
      const filteredEpisodeTypes = this.episodeTypesList.filter(x =>
        params.data['EpisodeTypeIds'].includes(x.id as string)
      )
      const episodeTypeNamesArray = filteredEpisodeTypes.map((item: any) => {
        return item.text
      })

      this.episodeTypeName = episodeTypeNamesArray.join(', ')
    }
  }

  refresh(params: any): boolean {
    return false
  }
}
